export default __webpack_public_path__ + "static/media/EfrontBackground.d9728f48.jpg";